import React from "react";
import {Row, Spin} from "antd";
import Text from "antd/es/typography/Text";
import {InfoCircleOutlined} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import Modal from "../../shared/modal/Modal";
import PopupService from "../../../model/service/dataStorage/PopupSevice";
import IPopup from "../../../model/interface/dataStorage/IPopup";
import LocaleText from "../settings/dictionary/LocaleText";
import Utils from "../../../utils";
import Button from "../../shared/button/Button";
import {IAppState} from "../../../redux/store";
import selectors from "../../../redux/selectors";
import {connect} from "react-redux";
import IconBuilder from "../../../utils/IconBuilder";

interface IState {
    loading: boolean
    popup?: IPopup,
    visible?: boolean
    seenStack: string[]
}

interface IProps {
    stack?: string[]
    onFinish?: () => void
    onCancel?: () => void
    zIndex?: number
    getText: (code: string, fallBack?: string) => string
}

class PopupModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            visible: true,
            seenStack: []
        }
    }

    componentDidMount() {
        this.load()
    }

    load() {
        const {stack} = this.props
        this.setState({loading: true})
        const identifier = stack?.find(p => !this.state.seenStack.includes(p))
        identifier && PopupService.resourceCheckRetrieve(identifier).then(popup => {
            this.setState(state => ({popup, loading: false, seenStack: [...state.seenStack, identifier]}))
        }).catch((e) => {
            this.setState(state => ({loading: false, seenStack: [...state.seenStack, identifier]}), this.onCancel)
        })
    }

    componentDidUpdate() {
        const {loading, popup, visible} = this.state
        const {stack} = this.props
        if (!loading && visible && (!popup || !stack?.includes(popup.uuid))) {
            this.load()
        }
    }

    onCancel = () => {
        if (this.state.seenStack.length !== this.props.stack?.length){
            return this.load()
        }
        this.props.onCancel?.()
        this.setState({visible: false})
    }

    finish = () => {
        if (this.state.seenStack.length !== this.props.stack?.length){
            return this.load()
        }
        this.props.onFinish?.()
        this.setState({visible: false})
    }

    render() {
        const {zIndex, getText} = this.props
        const {loading, popup, visible} = this.state

        if (!popup){
            return <></>
        }

        const {okButtonOptions, cancelButtonOptions} = popup

        return (
                <Modal className={'dir-ltr'}
                       title={
                           <Title level={4} className={'m-0'}>
                               <Text className={'pr-2 font-size-l'}>
                                   <InfoCircleOutlined/>
                               </Text>
                               <LocaleText code={popup.title || ''}/>
                           </Title>
                       }
                       zIndex={zIndex || undefined}
                       closable={popup.closeable === true}
                       maskClosable={popup.closeable === true}
                       width={600}
                       visible={visible}
                       onCancel={this.onCancel}
                       destroyOnClose={true}
                       footer={[
                           <Row justify={"space-between"}>
                               <Button  onClick={this.finish}
                                   type={okButtonOptions?.type}
                                   danger={Utils.toBoolean(okButtonOptions?.danger)}
                                   style={{background: okButtonOptions?.color, color: okButtonOptions?.textColor}}
                                   icon={okButtonOptions?.icon && IconBuilder(okButtonOptions.icon)}
                                   size={okButtonOptions?.size}
                               >
                                   {typeof okButtonOptions?.label === 'string' ? getText(okButtonOptions.label || '') : okButtonOptions?.label}
                               </Button>
                               <Button  onClick={this.onCancel}
                                        type={cancelButtonOptions?.type}
                                        danger={Utils.toBoolean(cancelButtonOptions?.danger)}
                                        style={{background: cancelButtonOptions?.color, color: cancelButtonOptions?.textColor}}
                                        icon={cancelButtonOptions?.icon && IconBuilder(cancelButtonOptions?.icon)}
                                        size={cancelButtonOptions?.size}
                               >
                                   {typeof cancelButtonOptions?.label === 'string' ? getText(cancelButtonOptions.label || '') : cancelButtonOptions?.label}
                               </Button>
                           </Row>
                       ]}
                >
                    {loading ? <Row justify={"center"}><Spin size={"large"}/></Row> : popup ? (
                        <div dangerouslySetInnerHTML={{__html: popup.content}}/>
                    ) : 'Požadovaný popup zřejmě neexistuje'}
                </Modal>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback)

    }
}

export default connect(mapStateToProps)(PopupModal)